/* unplugin-vue-components disabled */import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.last-index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-61194b76"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "device-alarm-handle"
};
var _hoisted_2 = {
  class: "list-detail"
};
var _hoisted_3 = {
  class: "list-detail-block"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "img-label"
  }, "图片/视频", -1);
});
var _hoisted_5 = {
  key: 1,
  class: "video-wrap"
};
var _hoisted_6 = ["src"];
var _hoisted_7 = {
  class: "bottom-submit"
};
import './handle.less';
import './common.less';
import { showToast } from 'vant';
import { delImage, uploadImage, postWarnHandle } from '@/service/deviceAlarm/index';
export default /*#__PURE__*/_defineComponent({
  __name: 'HandleAlarm',
  setup: function setup(__props) {
    var router = useRouter();
    var route = useRoute();
    var id = route.query.id;
    var formRef = ref('');
    var imgList = ref([]);
    var imgIdList = ref([]);
    var result = ref('');
    var loading = ref(false);
    var beforePath = ref({});
    router.beforeEach(function (to, from) {
      beforePath.value = from.fullPath;
      console.log(from.fullPath, 'from.fullPath');
      return true;
    });
    var maxCount = ref(9);
    var videoFile = ref(null);
    // 上传图片
    var ImgUploadFile = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(fileList) {
        var formData, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              // 要把数据变成file格式
              console.log(fileList, 'fileList');
              formData = new FormData();
              fileList.map(function (item) {
                formData.append('file', item.file);
                // formData.append('id', id as any);
              });
              _context.next = 6;
              return uploadImage(formData);
            case 6:
              data = _context.sent;
              return _context.abrupt("return", Promise.resolve(data));
            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              return _context.abrupt("return", Promise.reject());
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 10]]);
      }));
      return function ImgUploadFile(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var beforeRead = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(file) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                var fileType = ['png', 'jpg', 'jpeg', 'gif', 'mp4', 'MP4', 'mov', 'MOV', 'flv', 'FLV'];
                var isImg = false;
                var fileExtension = '';
                if (file.name.lastIndexOf('.') > -1) {
                  fileExtension = file.name.slice(file.name.lastIndexOf('.') + 1);
                }
                isImg = fileType.some(function (type) {
                  if (file.type.indexOf(type) > -1) return true;
                  if (fileExtension && fileExtension.indexOf(type) > -1) return true;
                  return false;
                });
                if (!isImg) {
                  showToast('仅支持上传图片或视频！');
                  return reject(false);
                }
                return resolve();
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function beforeRead(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var afterRead = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(file) {
        var status, data, fileList;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              status = Array.isArray(file);
              _context3.prev = 1;
              file.status = 'uploading';
              file.message = '上传中...';
              data = {};
              if (!status) {
                _context3.next = 13;
                break;
              }
              fileList = [];
              file.map(function (item) {
                fileList.push(item);
              });
              _context3.next = 10;
              return ImgUploadFile(fileList);
            case 10:
              data = _context3.sent;
              _context3.next = 16;
              break;
            case 13:
              _context3.next = 15;
              return ImgUploadFile([file]);
            case 15:
              data = _context3.sent;
            case 16:
              imgIdList.value.push(data.attchId);
              if (!getFileImage(data.url)) {
                videoFile.value = _objectSpread(_objectSpread({}, data), {}, {
                  id: data.attchId
                });
              }
              file.id = data.attchId;
              file.message = '上传成功';
              file.status = 'successed';
              showToast('上传成功');
              _context3.next = 28;
              break;
            case 24:
              _context3.prev = 24;
              _context3.t0 = _context3["catch"](1);
              file.status = 'failed';
              file.message = '上传失败';
            case 28:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 24]]);
      }));
      return function afterRead(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var delImg = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(file) {
        var index;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return delImage(file === null || file === void 0 ? void 0 : file.id);
            case 3:
              if (file.url && !getFileImage(file.url)) {
                videoFile.value = null;
                imgList.value = [];
                imgIdList.value = [];
              }
              if (file.url && getFileImage(file.url)) {
                index = imgIdList.value.findIndex(function (item) {
                  return item == (file === null || file === void 0 ? void 0 : file.id);
                });
                imgIdList.value.splice(index, 1);
              }
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.log(_context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }));
      return function delImg(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    // 判断是否是图片
    var getFileImage = function getFileImage(name) {
      var reg = /png$|jpeg$|gif$|jpg$/;
      return reg.test(name);
    };
    var videoRef = function videoRef(event) {
      if (event) {
        event['disablePictureInPicture'] = true;
      }
    };
    var onSubmit = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var imgId, res, timer, _timer;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              loading.value = true;
              _context5.next = 4;
              return formRef.value.validate();
            case 4:
              imgId = _toConsumableArray(imgIdList.value);
              if (videoFile.value) {
                imgId.push(videoFile.value.id);
              }
              _context5.next = 8;
              return postWarnHandle({
                id: Number(id),
                result: result.value,
                attachIds: imgId.join(',')
              });
            case 8:
              res = _context5.sent;
              loading.value = false;
              if (res.status == '1') {
                showToast.success("\u5904\u7406\u6210\u529F");
                timer = setTimeout(function () {
                  clearTimeout(timer);
                  router.push({
                    path: '/deviceAlarm',
                    query: {
                      deviceWarnStatus: '0',
                      id: id
                    }
                  });
                }, 500);
              } else {
                showToast("\u5904\u7406\u5931\u8D25");
                _timer = setTimeout(function () {
                  clearTimeout(_timer);
                  router.back();
                }, 500);
              }
              _context5.next = 16;
              break;
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](0);
              loading.value = false;
            case 16:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[0, 13]]);
      }));
      return function onSubmit() {
        return _ref5.apply(this, arguments);
      };
    }();
    onMounted(function () {
      //
    });
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_van_uploader = _resolveComponent("van-uploader");
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_form = _resolveComponent("van-form");
      var _component_van_button = _resolveComponent("van-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_van_form, {
        onSubmit: onSubmit,
        ref_key: "formRef",
        ref: formRef
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_field, {
            rows: "3",
            autosize: "",
            required: "",
            label: "处理结果",
            type: "textarea",
            placeholder: "请输入",
            modelValue: _unref(result),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(result) ? result.value = $event : null;
            }),
            rules: [{
              required: true,
              message: '请输入处理结果'
            }]
          }, null, 8, ["modelValue"]), _hoisted_4, !_unref(videoFile) ? (_openBlock(), _createBlock(_component_van_field, {
            key: 0,
            name: "uploader",
            class: "image-uploader"
          }, {
            input: _withCtx(function () {
              return [_createVNode(_component_van_uploader, {
                modelValue: _unref(imgList),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _isRef(imgList) ? imgList.value = $event : null;
                }),
                "after-read": afterRead,
                "max-count": _unref(maxCount),
                "before-read": beforeRead,
                onDelete: delImg
              }, null, 8, ["modelValue", "max-count"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _unref(videoFile) && _unref(videoFile).url ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("video", {
            src: _unref(videoFile).url,
            class: "video-content",
            controls: "",
            ref: videoRef,
            controlslist: "nodownload noremoteplayback noplaybackrate"
          }, null, 8, _hoisted_6), _createVNode(_component_van_icon, {
            name: "clear",
            class: "video-close",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return delImg(_unref(videoFile));
            })
          })])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 512)])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_van_button, {
        round: "",
        block: "",
        type: "primary",
        onClick: onSubmit,
        loading: _unref(loading)
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(" 确定 ")];
        }),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});